export default [
  {
    path: 'meetings',
    name: 'meetings',
    component: () => import('@/views/Meeting/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-create',
    name: 'meetingCreate',
    component: () => import('@/views/Meeting/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-content/:id',
    name: 'meetingContent',
    component: () => import('@/views/Meeting/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-update/:id',
    name: 'meetingUpdate',
    component: () => import('@/views/Meeting/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-batch-update-group/:id',
    name: 'meetingBatchUpdateGroup',
    component: () => import('@/views/Meeting/BatchUpdateGroup.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting/:meetingId/meeting-export-record-content/:exportRecordId',
    name: 'meetingExportRecordContent',
    component: () => import('@/views/Meeting/ExportRecord/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-copy/:id',
    name: 'meetingCopy',
    component: () => import('@/views/Meeting/Copy.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-template-create',
    name: 'meetingTemplateCreate',
    component: () => import('@/views/Meeting/Template/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-template-content/:id',
    name: 'meetingTemplateContent',
    component: () => import('@/views/Meeting/Template/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-template-copy/:id',
    name: 'meetingTemplateCopy',
    component: () => import('@/views/Meeting/Template/Copy.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
  {
    path: 'meeting-template-update/:id',
    name: 'meetingTemplateUpdate',
    component: () => import('@/views/Meeting/Template/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'meeting',
      template: 'auth',
    },
  },
];
